import requestRoutes from 'pages/requestForm/routes';

export const cacheManagerPaths = requestRoutes.reduce<string[]>((result, { path }) => {
    if (typeof path === 'string') result.push(path);

    return result;
}, []);
